<template lang="html">
  <div id="Login">
    <div class="background" />
    <div class="login">
      <el-row class="">
        <el-col class="fadeIn">
          <router-link to="/">
            <img class="logo" src="@/assets/logo/logo_transparent.png">
          </router-link>
        </el-col>
        <el-col class="slideUp">
          <a @click="login()" style="cursor: pointer;">
            <img src="@/assets/kakao_login_btn.jpg" class="kakao-login-btn" alt="kakao login button">
          </a>
        </el-col>
        <el-col align="middle">
          <a id="kakao-login-btn"></a>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { auth, getToken } from '@/firebase'
export default {
  name: 'Login',
  components: {},
  props: {
    to: null
  },
  beforeCreated() {
    this.getStatus()
  },
  data: () => ({
    isInit: false
  }),
  methods: {
    getStatus() {
      Kakao.Auth.getStatus(res => {
        this.$log.d(res)
        if (res.status !== 'not_connected') {
          this.onSuccess(res.user)
        }
      })
    },
    login() {
      // Kakao.Auth.loginForm()으로 하면 id/pw 입력창 뜸
      Kakao.Auth.login({
        success: res => {
          this.getUserProfile()
        },
        fail: err => {
          this.handleError(err)
          this.$vs.loading.close()
        }
      })
    },
    getUserProfile() {
      this.$vs.loading()
      Kakao.API.request({
        url: '/v2/user/me',
        success: res => {
          this.$log.d(res)
          // this.onSuccess(res)
          this.getFirebaseToken(res)
        },
        fail: err => {
          this.handleError(err)
          this.$vs.loading.close()
        }
      })
    },
    getFirebaseToken(user) {
      getToken(user.id).then(res => {
        this.$log.d('Success to get firebase token :', res)
        user['token'] = res.token
        this.firebaseLogin(user)
      }).catch(err => {
        this.$log.w(`Fail to get firebase token : ${err}`)
        this.$vs.loading.close()
      })
    },
    firebaseLogin(user) {
      auth.signInWithCustomToken(user.token).then(res => {
        this.$log.d('Success to firebase login', res)
        this.onSuccess(user)
      }).catch(err => {
        this.$log.w('Fail to firebase login', err)
        this.$vs.loading.close()
      })
    },
    onSuccess(user) {
      this.$vs.loading.close()

      // Save user info to store
      this.$store.commit('setUser', user)
      this.$router.push(this.$route.query.redirect || '/')
    },
    handleError(err) {
      this.$log.w(`This component threw an error (in '${err.target.outerHTML}'):`, this)
    }
  }
}

</script>
<style lang="scss" scoped>
#Login {
  display: flex;
  height: 100%;
  padding: 32px;
  margin-top: 20vh;

  .login {
    margin: auto;
    text-align: center;
    padding: 8px;
  }

  .logo {
    width: 200px;
    margin-bottom: 32px;
  }

  .kakao-login-btn {
    width: 250px;
  }

  .background {
    background-image: url('../../assets/main_background.png');
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    background-position: center;
    background-size: cover;
  }
}

/* Mobile */
@media only screen and (max-width : 768px) {
  #Login {
    .logo {
      width: 150px;
      margin-bottom: 32px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue